import { render, staticRenderFns } from "./SubscribeResultsMatches.vue?vue&type=template&id=d6f1d124&"
import script from "./SubscribeResultsMatches.vue?vue&type=script&lang=js&"
export * from "./SubscribeResultsMatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports